import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchAdminStats = createAsyncThunk('admin/fetchStats', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/admin/stats');
    return res.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed'); }
});

export const fetchAdminUsers = createAsyncThunk('admin/fetchUsers', async (params, { rejectWithValue }) => {
  try {
    const res = await api.get('/admin/users', { params });
    return res.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed'); }
});

export const fetchKitOverview = createAsyncThunk('admin/fetchKitOverview', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/admin/kit-overview');
    return res.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed'); }
});

export const fetchUserFullData = createAsyncThunk('admin/fetchUserFullData', async (userId, { rejectWithValue }) => {
  try {
    const res = await api.get(`/admin/users/${userId}/data`);
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed'); }
});

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    stats: null,
    kitOverview: null,
    users: [],
    pagination: { total: 0, page: 1, limit: 15, totalPages: 1 },
    selectedUser: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSelectedUser: (state) => { state.selectedUser = null; },
    clearAdminError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAdminStats.fulfilled, (state, action) => { state.stats = action.payload; });
    builder.addCase(fetchKitOverview.fulfilled, (state, action) => { state.kitOverview = action.payload; });

    builder.addCase(fetchAdminUsers.pending, (state) => { state.loading = true; });
    builder.addCase(fetchAdminUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.users = action.payload.users;
      state.pagination = action.payload.pagination;
    });
    builder.addCase(fetchAdminUsers.rejected, (state, action) => { state.loading = false; state.error = action.payload; });

    builder.addCase(fetchUserFullData.pending, (state) => { state.loading = true; });
    builder.addCase(fetchUserFullData.fulfilled, (state, action) => { state.loading = false; state.selectedUser = action.payload; });
    builder.addCase(fetchUserFullData.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export const { clearSelectedUser, clearAdminError } = adminSlice.actions;
export default adminSlice.reducer;
